import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
} from "@mui/material";

const PlaceOrderModal = ({ open, handleClose, handleSubmit }) => {
  const [formData, setFormData] = useState({
    item: "",
    userId: "",
  });

  const initialFormData = {
    item: "",
    userId: "",
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(formData);
    setFormData(initialFormData);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <form onSubmit={onSubmit}>
          <Typography variant="h3">Add your Order</Typography>
          <div>
            <TextField
              id="item"
              label="Item"
              name="item"
              variant="outlined"
              type="text"
              fullWidth
              value={formData.item}
              onChange={(e) => handleChange(e)}
            />
          </div>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button type="submit" onClick={onSubmit}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PlaceOrderModal;
